import { useContext } from 'react';
import { Routes, Route } from 'react-router-dom';
import { AppUserContext } from '../../App';
import { ErrorLoading } from '../../components/loading';
import ViewPaymentVouchers from './view-vouchers';
import NewVoucher from './voucher-manipulation';
import VoucherDetails from './view-voucher';


const PaymentVouchers = () => {

    const { profile } = useContext(AppUserContext);

    if (profile.permission_level > 2) {
        return <ErrorLoading>You do not have the permission to access requisitions.</ErrorLoading>
    }

    return (
        <Routes>
            <Route path="new" element={<NewVoucher />} />
            <Route path=":voucherid/*" element={<VoucherDetails />} />
            <Route path="/" element={<ViewPaymentVouchers />} />
        </Routes>
    )
};

export default PaymentVouchers;